/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineTask.vue?vue&type=template&id=225337a8&scoped=true"
import script from "./popMineTask.vue?vue&type=script&lang=js"
export * from "./popMineTask.vue?vue&type=script&lang=js"
import style0 from "./popMineTask.vue?vue&type=style&index=0&id=225337a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225337a8",
  null
  
)

export default component.exports